import { useEffect, useRef, useState } from 'react';

export const useDropdownOpen = (hasValue: boolean) => {
  const [isOpen, setOpen] = useState(hasValue);

  const prevHasValueRef = useRef(hasValue);

  const toggleOpen = () => setOpen(prev => !prev);

  useEffect(() => {
    const prevHasValue = prevHasValueRef.current;

    if (!prevHasValue && hasValue) {
      setOpen(true);
    }

    if (prevHasValue && !hasValue) {
      setOpen(false);
    }

    prevHasValueRef.current = hasValue;
  }, [hasValue]);

  return { isOpen, toggleOpen };
};
